import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import config from '../config/appConfig';
import '../styles/Navbar.css';

const Navbar = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = () => {
    logout();
    navigate('/');
  };

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/" className="navbar-logo">
          {config.appIcon} {config.appName}
        </Link>

        <div className="navbar-menu">
          {user ? (
            <>
              <Link 
                to={user.role === 'user' ? '/dashboard' : '/provider/dashboard'} 
                className="navbar-link"
              >
                Dashboard
              </Link>
              <span className="navbar-user">
                {user.firstName || user.organizationName || user.email}
              </span>
              <button onClick={handleLogout} className="navbar-button">
                Logout
              </button>
            </>
          ) : (
            <>
              <Link to="/login/user" className="navbar-link">
                Individual Login
              </Link>
              <Link to="/login/provider" className="navbar-link">
                Provider Login
              </Link>
              <Link to="/wholesale" className="navbar-link">
                Wholesale
              </Link>
              <Link to="/register/user" className="navbar-button">
                Get Started
              </Link>
            </>
          )}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
